
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import Brieffeld from '@/types/Brieffeld';
    import { InputValidationRule } from 'vuetify';
    import { ValidationRules } from '@/store/types';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
        },
    })
    export default class Brieffelder extends Vue {
        @PropSync('brieffelder') brieffelderSynced!: Brieffeld[];
        @Prop() platzhalter!: string[];
        @Prop({ default: () => false }) inhalt!: boolean;
        @Prop({ default: () => false }) readonly!: boolean;

        public $refs!: {
            textfelder: Vue[];
        };

        public rules!: ValidationRules;

        public get feld(): string {
            return this.inhalt ? 'inhalt' : 'vorgabe';
        }

        public brieffeldRules(feld: Brieffeld): InputValidationRule[] {
            return this.inhalt && (feld.bezeichnung ?? '').trim() ? [this.rules.required] : [];
        }

        public reset(): void {
            for (const textfeld of this.$refs.textfelder) {
                (textfeld.$refs.input as HTMLInputElement).style.height = '';
            }
        }
    }
